module.exports = require("react-stripe-elements");


//////////////////
// WEBPACK FOOTER
// external "react-stripe-elements"
// module id = 22
// module chunks = 0